module.exports = __webpack_public_path__ + "assets/img/img-care-banner@3x.5ca3622.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/care/img-care-banner@3x.jpg
// module id = 1096
// module chunks = 1